import script from "./NkFormItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./NkFormItem.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__